module.exports = __webpack_public_path__ + "static/img/college5.f0d176d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/college/college5.jpeg
// module id = uDdk
// module chunks = 45